import { vec3, vec4 } from 'gl-matrix';


export namespace _3DUtils {
  // ported from human.engine
  // src/rpc/procedures/deprecated.js Line 294
  export function getCanvasPos(
    Human: any,
    worldPos: [number, number, number],
    offset: [number, number, number],
    canvasWidth: number,
    canvasHeight: number
  ): [number, number] {
    if (offset) {
      vec3.add(worldPos as any, offset, worldPos);
    }

    const viewMat = Human.renderer.getViewMat();
    const projMat = Human.renderer.getProjMat();
    const projPos = vec4.create();

    vec3.transformMat4(projPos as any, worldPos, viewMat);
    projPos[3] = 1; // Need homogeneous 'w' for perspective division
    vec4.transformMat4(projPos, projPos, projMat);

    const x = projPos[0];
    const y = projPos[1];
    const w = projPos[3];

    return [
      Math.round(((1 + x / w) * canvasWidth) / 2),
      Math.round(((1 - y / w) * canvasHeight) / 2)
    ];
  }
}
